import ws from './912q5cQs6DL._SL1500_.jpg';
import themeasure from './themeasure.png';
import steklo from './Steklo.png';

export const books = [
  // {
  //   id: ,
  //   name: '',
  //   author: '',
  //   month: ' 2026',
  //   bookRating: '',
  //   cover: '',
  //   link: '',
  // },
  {
    id: 76,
    name: 'Связанные Импульсом: Стекло',
    author: 'Ангелина Пол',
    theme: 'cringe',
    month: 'August 2026',
    bookRating: '-',
    cover: steklo,
    link: '',
  },
  {
    id: 75,
    name: 'Lovely Girls',
    author: 'Margot Hunt',
    month: 'July 2026',
    bookRating: '3.5',
    cover: 'https://m.media-amazon.com/images/I/814Vs0RHeWL._UF1000,1000_QL80_.jpg',
    link: 'https://www.goodreads.com/book/show/59554746-lovely-girls',
  },
  {
    id: 74,
    name: 'Magpie Murders',
    author: 'Anthony Horowitz',
    theme: 'phoenix',
    month: 'June 2025',
    bookRating: '3.3',
    cover: 'https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1641067870i/32970179.jpg',
    link: 'https://www.goodreads.com/book/show/32970179-magpie-murders',
  },
  {
    id: 73,
    name: `Sweetpea`,
    author: 'C.J. Skuse',
    month: 'May 2026',
    bookRating: '4.2',
    cover: 'https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1525746842i/40058706.jpg',
    link: 'https://www.goodreads.com/book/show/40058706-sweetpea',
  },
  {
    id: 72,
    name: `The Housemaid`,
    author: 'Freida McFadden',
    month: 'April 2026',
    bookRating: '3.7',
    cover: 'https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1646534743i/60556912.jpg',
    link: 'https://www.goodreads.com/book/show/60556912-the-housemaid',
  },
  {
    id: 71,
    name: `Murder at Teal's Pond`,
    author: 'David Bushman, Mark T. Givens',
    theme: 'trueCrime',
    month: 'March 2026',
    bookRating: '3.0',
    cover: 'https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1622411888i/58206254.jpg',
    link: 'https://www.goodreads.com/book/show/58206254-murder-at-teal-s-pond',
  },
  {
    id: 70,
    name: 'Ready Player One',
    author: 'Ernest Cline',
    theme: 'regular',
    month: 'February 2026',
    bookRating: '4.0',
    cover: 'https://m.media-amazon.com/images/I/91FGDm7MfIL._AC_UF1000,1000_QL80_.jpg',
    link: 'https://www.goodreads.com/book/show/20603758-ready-player-one',
  },
  {
    id: 69,
    name: 'Skipping Christmas',
    author: 'John Grisham',
    theme: 'holiday',
    month: 'January 2026',
    bookRating: '3.6',
    cover: 'https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1542995348i/521019.jpg',
    link: 'https://www.goodreads.com/book/show/521019.Skipping_Christmas',
  },
  {
    id: 68,
    name: 'Handle with Care',
    author: 'Jodi Picoult',
    theme: 'regular',
    month: 'December 2025',
    bookRating: '3.3',
    cover: 'https://d28hgpri8am2if.cloudfront.net/book_images/onix/cvr9781439156308/handle-with-care-9781439156308_xlg.jpg',
    link: 'https://www.goodreads.com/book/show/3720975-handle-with-care',
  },
  {
    id: 67,
    name: 'Misery',
    author: 'Stephen King',
    theme: 'halloween',
    month: 'November 2025',
    bookRating: '4.3',
    cover: 'https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1451843098i/27877139.jpg',
    link: 'https://www.goodreads.com/book/show/59053857-misery',
  },
  {
    id: 66,
    name: 'Our Missing Hearts',
    author: 'Celeste Ng',
    theme: 'regular',
    month: 'October 2025',
    bookRating: '3.2',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1664802258i/60149573.jpg',
    link: 'https://www.goodreads.com/book/show/60149573-our-missing-hearts',
  },
  {
    id: 65,
    name: 'The Tokyo Zodiac Murders',
    author: 'Sōji Shimada',
    theme: 'regular',
    month: 'September 2025',
    bookRating: '3.0',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1441385091i/26159325.jpg',
    link: 'https://www.goodreads.com/book/show/26159325-the-tokyo-zodiac-murders',
  },
  {
    id: 64,
    name: 'ЭмоБой',
    author: 'Антон Соя',
    theme: 'cringe',
    month: 'August 2025',
    bookRating: '2.8',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1488873058i/34500721.jpg',
    link: 'https://www.goodreads.com/book/show/34500721',
  },
  {
    id: 63,
    name: 'Bear Necessity',
    author: 'James Gould-Bourn',
    theme: 'regular',
    month: 'July 2025',
    bookRating: '3.2',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1615805618i/57421246.jpg',
    link: 'https://www.goodreads.com/book/show/55711590-bear-necessity',
  },
  {
    id: 62,
    name: 'Les demoiselles',
    author: 'Anne-Gaëlle Huon',
    theme: 'phoenix',
    month: 'June 2025',
    bookRating: '3.9',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1719730226i/200818287.jpg',
    link: 'https://www.goodreads.com/book/show/200818287',
  },
  {
    id: 61,
    name: 'If Cats Disappeared from the World',
    author: 'Genki Kawamura',
    theme: 'regular',
    month: 'May 2025',
    bookRating: '3.0',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1536737551i/37901571.jpg',
    link: 'https://www.goodreads.com/book/show/37901571-if-cats-disappeared-from-the-world',
  },
  {
    id: 60,
    name: 'Осенняя жатва',
    author: 'Мария Гуцол',
    theme: 'regular',
    month: 'April 2025',
    bookRating: '2.7',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1569403588l/49700632.jpg',
    link: 'https://www.goodreads.com/book/show/49700632',
  },
  {
    id: 59,
    name: 'Три года в аду',
    author: 'Таня Щукина',
    theme: 'trueCrime',
    month: 'March 2025',
    bookRating: '4.4',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1719952078i/215955640.jpg',
    link: 'https://www.goodreads.com/book/show/215955640',
  },
  {
    id: 58,
    name: 'The Dutch House',
    author: 'Ann Patchett',
    theme: 'regular',
    month: 'February 2025',
    bookRating: '3.6',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1552334367i/44318414.jpg',
    link: 'https://www.goodreads.com/book/show/44318414-the-dutch-house',
  },
  {
    id: 57,
    name: 'One More for Christmas',
    author: 'Sarah Morgan',
    theme: 'holiday',
    month: 'January 2025',
    bookRating: '3.7',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1639759169i/59840961.jpg',
    link: 'https://www.goodreads.com/book/show/51473584-one-more-for-christmas',
  },
  {
    id: 56,
    name: 'The Fury',
    author: 'Alex Michaelides',
    theme: 'regular',
    month: 'December 2024',
    bookRating: '3.9',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1684763369i/125500880.jpg',
    link: 'https://www.goodreads.com/book/show/125500880-the-fury',
  },
  {
    id: 55,
    name: 'Twilight',
    author: 'Stephenie Meyer',
    theme: 'halloween',
    month: 'November 2024',
    bookRating: '4.9',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1330947557i/6358222.jpg',
    link: 'https://www.goodreads.com/book/show/41865.Twilight',
  },
  {
    id: 54,
    name: `Beneath Devil's Bridge`,
    author: 'Loreth Anne White',
    theme: 'regular',
    month: 'October 2024',
    bookRating: '3.9',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1603162253i/55526894.jpg',
    link: 'https://www.goodreads.com/book/show/55526894-beneath-devil-s-bridge',
  },
  {
    id: 53,
    name: 'Yellowface',
    author: 'R.F. Kuang',
    theme: 'regular',
    month: 'September 2024',
    bookRating: '3.6',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1671336740i/62060532.jpg',
    link: 'https://www.goodreads.com/book/show/62060532-yellowface',
  },
  {
    id: 52,
    name: 'Bad Cruz',
    author: 'L.J. Shen',
    theme: 'cringe',
    month: 'August 2024',
    bookRating: '2.5',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1633697267i/50724063.jpg',
    link: 'https://www.goodreads.com/book/show/50724063-bad-cruz',
  },
  {
    id: 51,
    name: 'The Measure',
    author: 'Nikki Erlick',
    theme: 'regular',
    month: 'July 2024',
    bookRating: '4.2',
    cover: themeasure,
    link: 'https://www.goodreads.com/book/show/58884736-the-measure',
  },
  {
    id: 50,
    name: 'The Unswitchable',
    author: 'Yoav Blum',
    theme: 'phoenix',
    month: 'June 2024',
    bookRating: '3.1',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1650435044i/60849571.jpg',
    link: 'https://www.goodreads.com/book/show/60849571',
  },
  {
    id: 49,
    name: 'Ninth House',
    author: 'Leigh Bardugo',
    theme: 'regular',
    month: 'May 2024',
    bookRating: '3.5',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1553102141i/43263680.jpg',
    link: 'https://www.goodreads.com/book/show/43263680-ninth-house',
  },
  {
    id: 48,
    name: `My Grandmother Asked Me to Tell You She's Sorry`,
    author: 'Fredrik Backman',
    theme: 'regular',
    month: 'April 2024',
    bookRating: '4.1',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1524175290i/25814222.jpg',
    link: 'https://www.goodreads.com/book/show/25814222-my-grandmother-asked-me-to-tell-you-she-s-sorry',
  },
  {
    id: 47,
    name: 'Know My Name',
    author: 'Chanel Miller',
    theme: 'trueCrime',
    month: 'March 2024',
    bookRating: '4.7',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1567612158l/50196744.jpg',
    link: 'https://www.goodreads.com/en/book/show/50196744',
  },
  {
    id: 46,
    name: 'Turtles All the Way Down',
    author: 'John Green',
    theme: 'regular',
    month: 'February 2024',
    bookRating: '3.9',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1503002776i/35504431.jpg',
    link: 'https://www.goodreads.com/book/show/35504431-turtles-all-the-way-down',
  },
  {
    id: 45,
    name: 'Winter Solstice',
    author: 'Rosamunde Pilcher',
    theme: 'holiday',
    month: 'January 2024',
    bookRating: '3.7',
    cover: ws,
    link: 'https://www.goodreads.com/book/show/116054.Winter_Solstice',
  },
  {
    id: 44,
    name: 'The Perks of Being a Wallflower',
    author: 'Stephen Chbosky',
    theme: 'regular',
    month: 'December 2023',
    bookRating: '4.2',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1407137888i/13573503.jpg',
    link: 'https://www.goodreads.com/book/show/13573503-the-perks-of-being-a-wallflower',
  },
  {
    id: 43,
    name: 'Mirrorland',
    author: 'Carole Johnstone',
    theme: 'halloween',
    month: 'November 2023',
    bookRating: '3.3',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1616939598i/54304146.jpg',
    link: 'https://www.goodreads.com/book/show/54304146-mirrorland',
  },
  {
    id: 42,
    name: 'Six of Crows',
    author: 'Leigh Bardugo',
    theme: 'regular',
    month: 'October 2023',
    bookRating: '3.4',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1651710803i/23437156.jpg',
    link: 'https://www.goodreads.com/book/show/23437156-six-of-crows',
  },
  {
    id: 41,
    name: 'The Fortnight in September',
    author: 'R.C. Sherriff',
    theme: 'regular',
    month: 'September 2023',
    bookRating: '3.4',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1628703512i/56898313.jpg',
    link: 'https://www.goodreads.com/book/show/56898313-the-fortnight-in-september',
  },
  {
    id: 40,
    name: 'A Court of Thorns and Roses',
    author: 'Sarah J. Maas',
    theme: 'cringe',
    month: 'August 2023',
    bookRating: '2.6',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1620324329i/50659467.jpg',
    link: 'https://www.goodreads.com/book/show/50659467-a-court-of-thorns-and-roses',
  },
  {
    id: 39,
    name: 'The Perfect Son',
    author: 'Lauren North',
    theme: 'regular',
    month: 'July 2023',
    bookRating: '3.3',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1559928017i/43073151.jpg',
    link: 'https://www.goodreads.com/book/show/43073151-the-perfect-son',
  },
  {
    id: 38,
    name: 'The Girl Before',
    author: 'J.P. Delaney',
    theme: 'phoenix',
    month: 'June 2023',
    bookRating: '3.5',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1485972587i/28016509.jpg',
    link: 'https://www.goodreads.com/book/show/28016509-the-girl-before',
  },
  {
    id: 37,
    name: 'Tomorrow, and Tomorrow, and Tomorrow',
    author: 'Gabrielle Zevin',
    theme: 'regular',
    month: 'May 2023',
    bookRating: '4.1',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1636978687i/58784475.jpg',
    link: 'https://www.goodreads.com/book/show/58784475-tomorrow-and-tomorrow-and-tomorrow',
  },
  {
    id: 36,
    name: 'The Midnight Library',
    author: 'Matt Haig',
    theme: 'regular',
    month: 'April 2023',
    bookRating: '3.3',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1602190253i/52578297.jpg',
    link: 'https://www.goodreads.com/book/show/52578297-the-midnight-library',
  },
  {
    id: 35,
    name: 'The Hive',
    author: 'Gregg Olsen',
    theme: 'trueCrime',
    month: 'March 2023',
    bookRating: '3.4',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1608586148i/52734671.jpg',
    link: 'https://www.goodreads.com/book/show/52734671-the-hive',
  },
  {
    id: 34,
    name: 'Eight Perfect Murders',
    author: 'Peter Swanson',
    theme: 'regular',
    month: 'February 2023',
    bookRating: '3.4',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1562582942l/52225186.jpg',
    link: 'https://www.goodreads.com/book/show/52225186-eight-perfect-murders',
  },
  {
    id: 33,
    name: 'White Elephant',
    author: 'Trish Harnetiaux',
    theme: 'holiday',
    month: 'January 2023',
    bookRating: '2.9',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1570362374i/38657803.jpg',
    link: 'https://www.goodreads.com/book/show/38657803-white-elephant',
  },
  {
    id: 32,
    name: 'Conversations with Friends',
    author: 'Sally Rooney',
    theme: 'regular',
    month: 'December 2022',
    bookRating: '2.5',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1638729263i/32187419.jpg',
    link: 'https://www.goodreads.com/book/show/32187419-conversations-with-friends',
  },
  {
    id: 31,
    name: 'Interview with the Vampire',
    author: 'Anne Rice',
    theme: 'halloween',
    month: 'November 2022',
    bookRating: '3.0',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1615558365i/57386222.jpg',
    link: 'https://www.goodreads.com/book/show/57386222-interview-with-the-vampire',
  },
  {
    id: 30,
    name: 'We Begin at the End',
    author: 'Chris Whitaker',
    theme: 'regular',
    month: 'October 2022',
    bookRating: '3.6',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1635841432i/57771227.jpg',
    link: 'https://www.goodreads.com/book/show/54280574-we-begin-at-the-end',
  },
  {
    id: 29,
    name: 'The First Day of Spring',
    author: 'Nancy Tucker',
    theme: 'regular',
    month: 'September 2022',
    bookRating: '4.2',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1603742328i/55801220.jpg',
    link: 'https://www.goodreads.com/book/show/55801220-the-first-day-of-spring',
  },
  {
    id: 28,
    name: 'The Secret Garden',
    author: 'Frances Hodgson Burnett',
    theme: 'regular',
    month: 'August 2022',
    bookRating: '3.6',
    cover: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1347475545i/805598.jpg',
    link: 'https://www.goodreads.com/book/show/805598.The_Secret_Garden',
  },
  {
    id: 27,
    name: 'The Thursday Murder Club',
    author: 'Richard Osman',
    theme: 'regular',
    month: 'July 2022',
    bookRating: '2.9',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1582287822l/46000520.jpg',
    link: 'https://www.goodreads.com/book/show/46000520-the-thursday-murder-club',
  },
  {
    id: 26,
    name: 'The Guernsey Literary and Potato Peel Pie Society',
    author: 'Mary Ann Shaffer, Annie Barrows',
    theme: 'regular',
    month: 'June 2022',
    bookRating: '3.6',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1351979318l/2728527.jpg',
    link: 'https://www.goodreads.com/book/show/2728527-the-guernsey-literary-and-potato-peel-pie-society',
  },
  {
    id: 25,
    name: 'Daisy Jones & The Six',
    author: 'Taylor Jenkins Reid',
    theme: 'phoenix',
    month: 'May 2022',
    bookRating: '3.6',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1580255154l/40597810._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/40597810-daisy-jones-the-six',
  },
  {
    id: 24,
    name: 'Practical Magic',
    author: 'Alice Hoffman',
    theme: 'regular',
    month: 'April 2022',
    bookRating: '3.2',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1446013485l/1281393._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/22896.Practical_Magic',
  },
  {
    id: 23,
    name: `Mindhunter: Inside the FBI's Elite Serial Crime Unit`,
    author: 'John E. Douglas, Mark Olshaker',
    theme: 'trueCrime',
    month: 'March 2022',
    bookRating: '4.7',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1555770031l/45181500._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/36100717-mindhunter',
  },
  {
    id: 22,
    name: 'Bullet Train',
    author: 'Kōtarō Isaka',
    theme: 'regular',
    month: 'February 2022',
    bookRating: '3.7',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1627738574l/56969543.jpg',
    link: 'https://www.goodreads.com/book/show/56969543-bullet-train',
  },
  {
    id: 21,
    name: 'One Day in December',
    author: 'Josie Silver',
    theme: 'holiday',
    month: 'January 2022',
    bookRating: '2.0',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1608122374l/56309332._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/56309332-one-day-in-december',
  },
  {
    id: 20,
    name: 'I am the Messenger',
    author: 'Markus Zusak',
    theme: 'regular',
    month: 'December 2021',
    bookRating: '3.5',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1398483261l/19057.jpg',
    link: 'https://www.goodreads.com/book/show/19057.I_Am_the_Messenger',
  },
  {
    id: 19,
    name: 'Verity',
    author: 'Colleen Hoover',
    theme: 'halloween',
    month: 'November 2021',
    bookRating: '3.6',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1608403534l/43225180._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/43225180-verity',
  },
  {
    id: 18,
    name: 'The Flatshare',
    author: `Beth O'Leary`,
    theme: 'regular',
    month: 'October 2021',
    bookRating: '3.9',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1605062910l/52340911._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/53287484-midnight-sun',
  },
  {
    id: 17,
    name: 'Midnight Sun',
    author: 'Stephenie Meyer',
    theme: 'regular',
    month: 'September 2021',
    bookRating: '4.0',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1588597375l/53287484.jpg',
    link: 'https://www.goodreads.com/book/show/53287484-midnight-sun',
  },
  {
    id: 16,
    name: 'The Last Mrs. Parrish',
    author: 'Liv Constantine',
    theme: 'regular',
    month: 'August 2021',
    bookRating: '3.4',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1608152250l/36039837._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/36039837-the-last-mrs-parrish',
  },
  {
    id: 15,
    name: 'The One',
    author: 'John Marrs',
    theme: 'regular',
    month: 'July 2021',
    bookRating: '3.4',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1589255853l/49374512.jpg',
    link: 'https://www.goodreads.com/book/show/49374512-the-one',
  },
  {
    id: 14,
    name: 'The 7½ Deaths of Evelyn Hardcastle',
    author: 'Stuart Turton',
    theme: 'phoenix',
    month: 'June 2021',
    bookRating: '4.3',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1543386631l/40914164.jpg',
    link: 'https://www.goodreads.com/book/show/40914164-the-7-1-2-deaths-of-evelyn-hardcastle',
  },
  {
    id: 13,
    name: 'The House at the Edge of Night',
    author: 'Catherine Banner',
    month: 'May 2021',
    bookRating: '3.0',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1490813483l/34052352.jpg',
    link: 'https://www.goodreads.com/book/show/34052352-the-house-at-the-edge-of-night',
  },
  {
    id: 12,
    name: 'Chocolat',
    author: 'Joanne Harris',
    theme: 'regular',
    month: 'April 2021',
    bookRating: '3.5',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1398921955l/321574.jpg',
    link: 'https://www.goodreads.com/book/show/321574.Chocolat',
  },
  {
    id: 11,
    name: 'The Shell Seekers',
    author: 'Rosamunde Pilcher',
    theme: 'regular',
    month: 'March 2021',
    bookRating: '3.9',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1428638731l/23014724.jpg',
    link: 'https://www.goodreads.com/book/show/23014724-the-shell-seekers',
  },
  {
    id: 10,
    name: `The Hypnotist's Love Story`,
    author: 'Liane Moriarty',
    theme: 'regular',
    month: 'February 2021',
    bookRating: '3.9',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1503177569l/36071330.jpg',
    link: 'https://www.goodreads.com/book/show/36071330-the-hypnotist-s-love-story',
  },
  {
    id: 9,
    name: 'Crave',
    author: 'Tracy Wolff',
    theme: 'regular',
    month: 'January 2021',
    bookRating: '2.1',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1578850525l/45892228.jpg',
    link: 'https://www.goodreads.com/book/show/45892228-crave',
  },
  {
    id: 8,
    name: 'You',
    author: 'Caroline Kepnes',
    theme: 'regular',
    month: 'December 2020',
    bookRating: '4.1',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1549463282l/36430011._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/36430011-you',
  },
  {
    id: 7,
    name: 'Extremely Loud and Incredibly Close',
    author: 'Jonathan Safran Foer',
    theme: 'regular',
    month: 'November 2020',
    bookRating: '2.9',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1327879967l/4588.jpg',
    link: 'https://www.goodreads.com/book/show/4588.Extremely_Loud_Incredibly_Close',
  },
  {
    id: 6,
    name: 'The Other Boleyn Girl',
    author: 'Philippa Gregory',
    theme: 'regular',
    month: 'October 2020',
    bookRating: '3.7',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1573082070l/48722935.jpg',
    link: 'https://www.goodreads.com/book/show/48722935-the-other-boleyn-girl',
  },
  {
    id: 5,
    name: 'Love, Rosie',
    author: 'Cecelia Ahern',
    theme: 'regular',
    month: 'September 2020',
    bookRating: '3.0',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1420732457l/147865.jpg',
    link: 'https://www.goodreads.com/book/show/147865.Love_Rosie',
  },
  {
    id: 4,
    name: 'Little Women',
    author: 'Louisa May Alcott',
    theme: 'regular',
    month: 'August 2020',
    bookRating: '3.5',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1328753097l/93019.jpg',
    link: 'https://www.goodreads.com/book/show/93019.Little_Women',
  },
  {
    id: 3,
    name: 'A Little Life',
    author: 'Hanya Yanagihara',
    theme: 'regular',
    month: 'July 2020',
    bookRating: 0,
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1446469353l/22822858._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/22822858-a-little-life',
  },
  {
    id: 2,
    name: 'The Outsider',
    author: 'Stephen King',
    theme: 'regular',
    month: 'June 2020',
    bookRating: '3.0',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1524596540l/36124936._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/36124936-the-outsider',
  },
  {
    id: 1,
    name: 'Little Fires Everywhere',
    author: 'Celeste Ng',
    theme: 'regular',
    month: 'May 2020',
    bookRating: '4.4',
    cover: 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1551568314l/44177149._SY475_.jpg',
    link: 'https://www.goodreads.com/book/show/51704136-little-fires-everywhere',
  }
]
